
import { Card } from "@/components/ui/card";
import { Navbar } from "@/components/layout/Navbar";
import { CompleteRegistrationForm } from "@/components/auth/form/CompleteRegistrationForm";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

const CompleteRegistration = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        navigate("/register");
      }
    };

    checkAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
            Compléter votre profil
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Renseignez les informations de votre entreprise
          </p>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <Card className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <CompleteRegistrationForm />
          </Card>
        </div>
      </div>
    </div>
  );
};

export default CompleteRegistration;
